import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const ProvingDetailsResourceRequirementStatusForm: React.FunctionComponent =
  () => {
    const { t } = useTranslation()

    const options: IDropdownOption[] = [
      {
        key: 'notRequired',
        text: t('dropdown.option.ResourceRequirements.status.notRequired'),
      },
      {
        key: 'open',
        text: t('dropdown.option.ResourceRequirements.status.open'),
      },
      {
        key: 'inProgress',
        text: t('dropdown.option.ResourceRequirements.status.inProgress'),
      },
      {
        key: 'finished',
        text: t('dropdown.option.ResourceRequirements.status.finished'),
      },
    ]

    return (
      <FormStack>
        <FieldStack>
          <FieldStackItem
            name="status"
            render={(fieldProps: FieldProps<any>) => (
              <FormikDropdown
                label={t('field.status.label')}
                {...fieldProps}
                options={options}
                required={true}
              />
            )}
          />
        </FieldStack>
      </FormStack>
    )
  }
